import React, { act, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';
import { use } from 'react';


function ClientDetails() {
  const authToken = localStorage.getItem('token');
  const userId = localStorage.getItem('userID');
  const baseurl = process.env.REACT_APP_BASE_API_URL;

  const [userData, setUserData] = useState(null);
  const [fundAmount, setFundAmount] = useState(0);
  const [wallet, setWallet] = useState(null);
  const [income, setIncome] = useState(null);
  const [deposit, setDeposit] = useState([]);
  const [withdraw, setWithdraw] = useState([]);
  const [stakeData, setStakes] = useState([]);
  const [userDetails, setUserDetails] = useState([])
  const [isLoading, setLoading] = useState(false);
  const [isDeposit, setDepositScreen] = useState(true);
  const [tabelLoading, setTableLoading] = useState(true);
  const [packageAmount, setPackageAmount] = useState(10);
  const [pagination, setPagination] = useState({
    current_page: 1,
    limit: 10,
    total_records: 0,
    total_pages: 0,
  });

  useEffect(() => {


    fetchProfileData();
  }, [userId, authToken, baseurl]);

  const handleProfileDataFetched = (data) => {
    // Optional: Handle Auth result
  };

  const fetchProfileData = async () => {
    if (!userId) {
      toast.error('No User ID provided in URL.');
      setLoading(false);
      setTableLoading(false);
      return;
    }

    setLoading(true);
    setTableLoading(false);

    try {
      const formData = new URLSearchParams();
      formData.append('user_id', userId);

      const response = await axios.post(
        `${baseurl}/userDetails.php`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );

      const data = response.data;

      console.log('User Data', data);

      if (data.status) {
        setUserDetails(data.user_data);
        setStakes(data.stakes);

      } else {
        toast.error(data.message || 'Failed to fetch user details.');
        return;
      }


    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
          error.response?.status === 401 ? 'Unauthorized access. Please log in again.' :
          error.response?.status === 404 ? 'User not found.' :
            'Error fetching user details.';
      toast.error(errorMessage);
      console.error('Fetch Profile Error:', error);
    } finally {
      setLoading(true);
      setTableLoading(true);
    }
  };

  const userDataSET = async (data) => {
    console.log(data)
    setuserName(data.name);
    setUserEmail(data.email);
    setUserMobile(data.mobile);
    setUserWithdrawStatus(data.withdrawStatus);
    setUserAccountStatus(data.accountStatus);
    setUserstakeseStatus(data.f_status);

  }



  const [userName, setuserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userMobile, setUserMobile] = useState("");
  const [userWithdrawStatus, setUserWithdrawStatus] = useState("");
  const [userAccountStatus, setUserAccountStatus] = useState("");
  const [userstakeseStatus, setUserstakeseStatus] = useState("");




  const handelUpdate = async () => {

    const formData = new URLSearchParams();
    formData.append('user_id', userId);
    formData.append('name', userName);
    formData.append('email', userEmail);
    formData.append('mobile', userMobile);
    formData.append('withdraw_status', userWithdrawStatus);
    formData.append('account_status', userAccountStatus);

    try {
      const response = await axios.post(
        `${baseurl}/editUser.php`,

        formData
        ,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );

      const data = response.data;

      console.log('data', data);

      if (!data.status) {
        toast.error(data.message || "Something went wrong!");
      }

      toast.success(data.message);

    } catch (error) {
      toast.error("Error fetching user details.");
      console.error(error);
    } finally {
      setLoading(false);
      // window.location.href = "";
    }

  }







  const activePackges = async () => {
    const formData = new URLSearchParams();
    formData.append('user_id', userId);
    formData.append('stakeAmount', packageAmount);
    formData.append('stakeCoin', 'USDT');


    try {
      const response = await axios.post(
        `${baseurl}/stake.php`,

        formData
        ,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );

      const data = response.data;

      console.log('data', data);

      if (!data.status) {
        toast.error(data.message || "Something went wrong!");
      }

      toast.success(data.message);

    } catch (error) {
      toast.error("Error fetching user details.");
      console.error(error);
    } finally {
      setLoading(false);
      // window.location.href = "";
    }

  }



  const fetchDataWithdrawals = async (page) => {
    setTableLoading(false);
    const queryParams = new URLSearchParams({
      page,
      userid: userId,
    }).toString();

    try {
      const response = await fetch(`${baseurl}/withdrawList.php?${queryParams}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status === 429) {
        toast.error('Rate limit exceeded. Please try again later.');
        setTableLoading(true);
        return;
      }

      const data = await response.json();
      console.log('API Response:', data);

      if (data.status) {
        setWithdraw(data.data);
        setPagination(data.pagination);

        setTableLoading(true);
      } else {
        toast.error(data.message || 'Failed to fetch withdrawal data');
        setTableLoading(true);
      }
    } catch (error) {
      console.error('Fetch error:', error);
      toast.error('Network error. Please check your connection and try again.');
      setTableLoading(true);
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= pagination.total_pages) {
      fetchDataWithdrawals(page);
    }
  };

  const searchData = () => {
    fetchDataWithdrawals(1);
  };


  return (
    <>
      <Header>
        {!authToken && <Auth onProfileDataFetched={handleProfileDataFetched} />}

        <div className="main-content app-content">
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">Hi, welcome back!</h4>
              </div>
            </div>

            {/* Table Section */}
            <div className="row row-sm">
              <div className="col-xl-4">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="ps-0">
                      <div className="main-profile-overview">
                        <div className="text-center">
                          <span className="avatar avatar-xxl avatar-rounded main-img-user profile-user user-profile">
                            <img src={'assets/images/profile/profile1.avif'} alt="" className="profile-img" />

                            <input type="file" name="photo" className="position-absolute profile-change w-100 h-100 op-0" id="" />
                            <i className="fe fe-camera" />

                          </span>
                          <div className="">
                            <div className="text-center">
                              <h5 className="main-profile-name">{userDetails ? userDetails.name : 'Loading....'}</h5>
                              <p className="main-profile-name-text text-muted">{userDetails ? userDetails.email : 'Loading....'}</p>
                            </div>
                            <div className="mt-2">
                              <span>Status:{userDetails ? userDetails.accountStatus : 'N/A'}</span>

                            </div>
                          </div>
                        </div>
                        <hr />
                        {/* main-profile-bio */}
                        <div className="row text-center">
                          <div className="col-md-4 col mb20">
                            <h5 className="fs-17">{userDetails ? userDetails.totalTeam : 'Loading....'}</h5>
                            <h6 className="text-small text-muted fs-14 mb-0">Team</h6>
                          </div>
                          <div className="col-md-4 col mb20">
                            <h5 className="fs-17">{userDetails ? userDetails.myBusiness : 'Loading....'}</h5>
                            <h6 className="text-small text-muted fs-14 mb-0">My Business</h6>
                          </div>
                          <div className="col-md-4 col mb20">
                            <h5 className="fs-17">{userDetails ? userDetails.teamBusiness : 'Loading....'}</h5>
                            <h6 className="text-small text-muted fs-14 mb-0">Team Business</h6>
                          </div>
                        </div>

                        <hr className="border-1" />

                      </div>
                      {/* main-profile-overview */}
                      <div className="row">
                        <div className="col-12 mb-20">
                          <span>Mobile :-</span>
                          <h6>{userDetails ? userDetails.mobile : 'N/A'}</h6>
                        </div>
                        <div className="col-12 mb-20">
                          <span>Join Date :-</span>
                          <h6>{userDetails ? userDetails.joidDate : 'N/A'} {userDetails ? userDetails.joinTime : 'N/A'}</h6>
                        </div>
                        <div className="col-12 mb-20">
                          <span>Password :-</span>
                          <h6 className="text-danger">{userDetails ? userDetails.password : 'N/A'}</h6>
                        </div>
                      </div>
                      <div className="mt-2">
                        <button className='btn btn-primary w-100' data-bs-toggle="modal" data-bs-target="#addAssetModal" onClick={() => userDataSET(userDetails)} >Edit Details</button>
                      </div>
                      <div className="mt-2">
                        <button className='btn btn-success w-100' data-bs-toggle="modal" data-bs-target="#activePackage"  >STAKE</button>
                      </div>


                    </div>
                  </div>
                </div>

              </div>

              <div className="col-xl-8">
                <div className="row row-sm">


                  <div className="col-sm-12 col-lg-4 col-md-12">
                    <div className="card ">
                      <div className="card-body">
                        <div className="counter-status d-flex md-mb-0">
                          <div className="counter-icon bg-primary-transparent">
                            <i className="icon-layers text-primary" />
                          </div>
                          <div className="ms-auto">
                            <h5 className="fs-13">Stake Amount </h5>
                            <h6 className="mb-0  mb-1 mt-1">${userDetails ? userDetails.stakeAmount : '0'}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-lg-4 col-md-12">
                    <div className="card ">
                      <div className="card-body">
                        <div className="counter-status d-flex md-mb-0">
                          <div className="counter-icon bg-danger-transparent">
                            <i className="icon-paypal text-danger" />
                          </div>
                          <div className="ms-auto">
                            <h5 className="fs-13">Stake Coin </h5>
                            <h6 className="mb-0  mb-1 mt-1">R {userDetails ? userDetails.stakeCoin : '0'}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-lg-4 col-md-12">
                    <div className="card ">
                      <div className="card-body">
                        <div className="counter-status d-flex md-mb-0">
                          <div className="counter-icon bg-success-transparent">
                            <i className="icon-rocket text-success" />
                          </div>
                          <div className="ms-auto">
                            <h5 className="fs-13">Credit Coin</h5>
                            <h6 className="mb-0  mb-1 mt-1">R {userDetails ? userDetails.creditCoin : '0'}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <div className="row row-sm">
                  <div className="col-12">
                    <div className="card card-table">
                      <div className="card-header p-0 d-flex justify-content-between mt-3">
                        <h3 className="card-title mb-1 text-primary">Stakes</h3>
                      </div>
                      <div className="row mt-3">
                        <div className="table-responsive country-table">
                          {isLoading ? (
                            <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                              <thead>
                                <tr>
                                  <th className="wd-lg-25p">Amount</th>
                                  <th className="wd-lg-25p">Stake Raino</th>
                                  <th className="wd-lg-25p">Mining Return</th>
                                  <th className="wd-lg-25p">Daily Credit</th>
                                  <th className="wd-lg-25p">Total Credit</th>
                                  <th className="wd-lg-25p">Stake date</th>
                                  <th className="wd-lg-25p">Last update</th>
                                </tr>
                              </thead>

                              <tbody>
                                {stakeData.length > 0 ? (
                                  stakeData.map((stake, index) => (
                                    <tr key={index}>
                                      <td> ${stake.amount || '0'} </td>
                                      <td>Raino {stake.stakeCoin || '0'} </td>
                                      <td>  {stake.dailyPerReturn || '0'}% </td>
                                      <td> Raino {stake.dailyCredit || '0'} </td>
                                      <td> Raino {stake.TotalCredit || '0'} </td>
                                      <td> {stake.DateTime || '0'} </td>
                                      <td> {stake.MineDateTime || '0'} </td>

                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td>No Data Found</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          ) : (
                            <div className="text-center">
                              <div class="d-flex justify-content-center mb-4">
                                <div class="spinner-border" role="status">
                                  <span class="visually-hidden">Loading...</span>
                                </div>
                              </div>
                            </div>
                          )}


                        </div>

                      </div>
                    </div>
                  </div>


                </div>
              </div>

              <div className="card card-body">

                <div className="row">
                  <div className="col-md-12 col-lg-12 col-xl-12">
                    <div className="card card-table">
                      <div className='row'>
                        <div className='col-10'>
                          <h3 className="card-title mb-1 text-primary">Withdraw Data</h3>
                        </div>
                        <div className='col-2 text-end'>
                          <button className='btn btn-primary btn-sm' onClick={() => fetchDataWithdrawals(1)}><i className='fa fa-eye'></i></button>
                        </div>
                      </div>
                      <div className="table-responsive country-table">
                        {tabelLoading ? (
                          <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                            <thead>
                              <tr>
                                <th className="wd-lg-25p">Available Amount</th>
                                <th className="wd-lg-25p">Withdraw Amount</th>
                                <th className="wd-lg-25p">Remain Amount</th>
                                <th className="wd-lg-25p">Wallet Address</th>
                                <th className="wd-lg-25p">Txn HAsh</th>
                                <th className="wd-lg-25p">Date Time</th>
                                <th className="wd-lg-25p">Status</th>
                              </tr>
                            </thead>

                            <tbody>
                              {withdraw.length > 0 ? (
                                withdraw.map((withdrawdata, index) => (
                                  <tr key={index}>

                                    <td> {withdrawdata.totalAmount || '0'} {withdrawdata?.withdrawAsset} </td>
                                    <td> {withdrawdata.withdrawAmount || 'N/A'} {withdrawdata?.withdrawAsset}  </td>
                                    <td> {withdrawdata.remainAmount || 'N/A'}  {withdrawdata?.withdrawAsset} </td>
                                    <td><a className="text-primary" href={`https://bscscan.com/address/` + withdrawdata.toAddress} target='blank'> {withdrawdata.toAddress ? `${withdrawdata.toAddress.slice(0, 5)}...${withdrawdata.toAddress.slice(-5)}` : 'N/A'} </a></td>
                                    <td> <a className="text-primary" href={`https://bscscan.com/tx/` + withdrawdata.txnHash} target='blank'>{withdrawdata.txnHash ? `${withdrawdata.txnHash.slice(0, 5)}...${withdrawdata.txnHash.slice(-5)}` : 'N/A'}</a> </td>
                                    <td> {withdrawdata.requestTime || 'N/A'} </td>
                                    <td>
                                      {withdrawdata && withdrawdata.status
                                        ? withdrawdata.status === 'success' ? (
                                          <span className="badge bg-success">Success</span>
                                        ) : (
                                          <span className="badge bg-danger">{withdrawdata.status} </span>
                                        ) : 'N/A'}
                                    </td>

                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td>No Data Found</td>
                                </tr>
                              )}
                            </tbody>

                          </table>
                        ) : (
                          <div className="text-center">
                            <div class="d-flex justify-content-center mb-4">
                              <div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                              </div>
                            </div>
                          </div>
                        )}


                      </div>
                      <div className="gridjs-footer">
                        <div className="gridjs-pagination">
                          <div
                            role="status"
                            aria-live="polite"
                            className="gridjs-summary"
                          >
                            Showing <b>{(pagination.current_page - 1) * pagination.limit + 1}</b> to{' '}
                            <b>
                              {Math.min(
                                pagination.current_page * pagination.limit,
                                pagination.total_records
                              )}
                            </b>{' '}
                            of <b>{pagination.total_records}</b> results
                          </div>
                          <div className="gridjs-pages text-end">
                            <button
                              className={pagination.current_page === 1 ? 'disabled' : ''}
                              onClick={() => handlePageChange(pagination.current_page - 1)}
                              disabled={pagination.current_page === 1}
                            >
                              Previous
                            </button>
                            <button
                              className={pagination.current_page === 1 ? 'gridjs-currentPage' : ''}
                              onClick={() => handlePageChange(1)}
                            >
                              1
                            </button>
                            {pagination.current_page > 3 && <span>...</span>}
                            {Array.from({ length: 5 }, (_, i) => {
                              const page = pagination.current_page - 2 + i;
                              if (page > 1 && page < pagination.total_pages) {
                                return (
                                  <button
                                    key={page}
                                    className={
                                      pagination.current_page === page ? 'gridjs-currentPage' : ''
                                    }
                                    onClick={() => handlePageChange(page)}
                                  >
                                    {page}
                                  </button>
                                );
                              }
                              return null;
                            })}
                            {pagination.current_page < pagination.total_pages - 2 && (
                              <span>...</span>
                            )}
                            {pagination.total_pages > 1 && (
                              <button
                                className={
                                  pagination.current_page === pagination.total_pages
                                    ? 'gridjs-currentPage'
                                    : ''
                                }
                                onClick={() => handlePageChange(pagination.total_pages)}
                              >
                                {pagination.total_pages}
                              </button>
                            )}
                            <button
                              class混乱
                              className={
                                pagination.current_page === pagination.total_pages ? 'disabled' : ''
                              }
                              onClick={() => handlePageChange(pagination.current_page + 1)}
                              disabled={pagination.current_page === pagination.total_pages}
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Table Section */}
          </div>
        </div>
      </Header>
      <Footer />
      <ToastContainer />

      <div className="modal fade" id="addAssetModal" tabIndex="-1" aria-labelledby="addAssetModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="addAssetModalLabel">Edit Details</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div className="modal-body">
              <div className="row">


                <div className="col-md-6 mt-4">
                  <label className="form-label">User Name</label>
                  <input type="text" className="form-control" name="requiredFromBalance" value={userName} onChange={(e) => setuserName(e.target.value)} placeholder="Enter profile image link" defaultValue="0" />
                </div>

                <div className="col-md-6 mt-4">
                  <label className="form-label">Email</label>
                  <input type="text" className="form-control" name="requiredToBalance" value={userEmail} onChange={(e) => setUserEmail(e.target.value)} placeholder="Enter Profile Link" defaultValue="0" />
                </div>

                <div className="col-md-6 mt-4">
                  <label className="form-label">Mobile</label>
                  <input type="text" className="form-control" name="requiredDownline" value={userMobile} onChange={(e) => setUserMobile(e.target.value)} placeholder="Enter Title" defaultValue="0" />
                </div>

                <div className="col-md-6 mt-4">
                  <label className="form-label">Withdraw Status</label>
                  <select className="form-control" onChange={(e) => setUserWithdrawStatus(e.target.value)}>
                    <option value={userWithdrawStatus}>{userWithdrawStatus}</option>
                    <option value={"active"}>active</option>
                    <option value={"hold"}>hold</option>

                  </select>
                </div>

                <div className="col-md-6 mt-4">
                  <label className="form-label">Account Status</label>
                  <select className="form-control" onChange={(e) => setUserAccountStatus(e.target.value)}>
                    <option value={userAccountStatus}>{userAccountStatus}</option>
                    <option value={"active"}>active</option>
                    <option value={"hold"}>hold</option>
                    <option value={"pending"}>pending</option>

                  </select>
                </div>


                <div className="col-md-12 mt-4 text-end">
                  <button type="submit" className="btn btn-success" onClick={handelUpdate}>Submit</button>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>



      <div className="modal fade" id="activePackage" tabIndex="-1" aria-labelledby="addAssetModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="addAssetModalLabel">Active Package</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div className="modal-body">
              <div className="row">



                <div className="col-md-12 mt-4">
                  <label className="form-label">Select Packages</label>
                  <select className="form-control" onChange={(e) => setPackageAmount(e.target.value)}>
                    <option value={"50"}>$50</option>
                    <option value={"100"}>$100</option>
                    <option value={"250"}>$250</option>
                    <option value={"500"}>$500</option>
                    <option value={"1000"}>$1000</option>
                  </select>
                </div>
                <div className="col-md-12 mt-4 text-end">
                  <button type="submit" className="btn btn-success" onClick={() => activePackges()}>Active Package</button>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>



    </>
  );
}

export default ClientDetails;
